import React from "react";
import Product from "./Product";

class Products extends React.Component {
  render() {
    let products = this.props.products;
    let shop = false;
    if (this.props.shop) {
      shop = true;
    }

    return (
      <section>
        <div className="columns is-multiline animated fadeIn">
          {products.length < 1 ? (
            <span></span>
          ) : (
            products.map((product, i) => (
              <div
                key={i + "-market-product-" + product.item.id}
                className="column is-one-quarter-desktop is-half-tablet is-one-sixth-widescreen"
              >
                <Product product={product} shop={shop} />
              </div>
            ))
          )}
        </div>
      </section>
    );
  }
}

export default Products;
